import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Select, { SelectItem } from '../../../Select';
import { FilterRow } from './FilterComponentFactory';
import { OperatorComponent } from './OperatorComponent';
export var PicklistFilterComponent = function PicklistFilterComponent(props) {
  var _filterableField$pick;

  var stateKey = props.stateKey,
      state = props.state,
      stateChangeFn = props.stateChangeFn,
      dsComponentProps = props.dsComponentProps,
      filterableField = props.filterableField;
  return /*#__PURE__*/React.createElement(FilterRow, null, /*#__PURE__*/React.createElement(Select, _extends({}, dsComponentProps, {
    label: state[stateKey].label || stateKey,
    dsOnChange: function dsOnChange(e) {
      stateChangeFn(_objectSpread(_objectSpread({}, state), {}, _defineProperty({}, stateKey, _objectSpread(_objectSpread({}, state[stateKey]), {}, {
        value: e.target.value
      }))));
    },
    value: state[stateKey].value
  }), filterableField === null || filterableField === void 0 ? void 0 : (_filterableField$pick = filterableField.picklistOptions) === null || _filterableField$pick === void 0 ? void 0 : _filterableField$pick.map(function (name, index) {
    return /*#__PURE__*/React.createElement(SelectItem, {
      value: name,
      key: "".concat(name, "+").concat(index)
    }, name);
  })), /*#__PURE__*/React.createElement(OperatorComponent, props));
};

try {
  PicklistFilterComponent.__docgenInfo = {
    description: '',
    displayName: 'PicklistFilterComponent',
    methods: [],
    props: {}
  };
} catch (e) {}
//# sourceMappingURL=PicklistFilterComponent.js.map